import { Navigate } from "react-router-dom";

/**
 * Higher-order component for protected routes
 * @param {React.Component} Component - The component to protect
 * @returns {React.Component} Protected component or redirect to login
 */
export const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("token");
  return token ? children : <Navigate to="/" replace />;
};

/**
 * Creates a protected route configuration
 * @param {string} path - Route path
 * @param {React.Component} component - Component to render
 * @param {object} props - Additional route props
 * @returns {object} Route configuration object
 */
export const createProtectedRoute = (path, component, props = {}) => ({
  path,
  element: <ProtectedRoute>{component}</ProtectedRoute>,
  ...props
});

/**
 * Checks authentication status
 * @returns {boolean} True if authenticated
 */
export const isAuthenticated = () => {
  return !!sessionStorage.getItem("token");
};

/**
 * Handles unknown routes
 * @returns {React.Component} Redirect component
 */
export const handleUnknownRoute = () => {
  return isAuthenticated() ? (
    <Navigate to="/bill" replace />
  ) : (
    <Navigate to="/" replace />
  );
};